module.exports = __webpack_public_path__ + "img/20.6c3c6c8d.jpg";